module.exports = __webpack_public_path__ + "static/img/gzh.b666e5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gzh.jpg
// module id = U52o
// module chunks = 1